{
  "languages": {
    "en": "English",
    "it": "Italiano"
  },
  "labels": {
    "page-title": "Measures",
    "name": "Name",
    "measure": "Measure",
    "type": "Type",
    "measures": "Measures",
    "search": "search",
    "create-measure": "Create measure",
    "cancel": "Cancel",
    "save": "Save",
    "duplicate": "Duplicate",
    "delete": "Delete",
    "refresh": "Refresh",
    "description": "Description",
    "required": "Field required",
    "open": "Open",
    "deleteMulti": "Delete Selected",
    "role": "Role",
    "send": "Send",
    "select": "Select",
    "context": "Context",
    "health-healthy": "Healthy",
    "health-unhealthy": "Unhealthy",
    "health-unknown": "Unknown",
    "last-check": "Last check"
  },
  "strings": {
    "new-measure": "new measure",
    "no-measures": "This list is empty",
    "please-add-measure": "Please add a new measure",
    "delete-measure-question": "Are you sure you want to to delete this measure?",
    "delete-measure-disclaimer-part1": "Deleting this measure will permanently remove it and any associated KPIs that depend on it. This action cannot be undone.",
    "delete-measure-disclaimer-part2": "If you are sure, click on DELETE to confirm.",
    "delete-multiple-measure-question": "Do you want to delete the selected measures?",
    "delete-measure-text": "Measure deleted",
    "delete-multiple-text": "Measures deleted",
    "delete-measure-tooltip": "Delete this measure",
    "hint-insert-new-name": "Insert a new name for the measure",
    "duplicate-advice": "ATTENTION: for security policy, if the Measure requires credentials, they will NOT be duplicated in the new measure.",
    "name-required": "Name is required",
    "name-less-20-chars": "The maximum length allowed is 20 characters",
    "value-required": "A value is required"
  },
  "errors": {
    "measure-name-exists": "This name is already in use"
  }
}